module.exports = __webpack_public_path__ + "question.svg?eb80ef37d7db35b8e6fcf714c6d1184b";